<template>
<transition name="moveR">
  <div v-show="isShow" class="zn-alpha-template">
    <component
      v-if="activeComponent"
      :is="activeComponent"
      ref="compt"
      :componentName="activeComponent"
      :item="item"
      @closeTpl="closeTpl"
    ></component>
  </div>
</transition>
</template>
<script>
import ZnNewProject from './ZnNewProject.vue'
import ZnNewCompany from './ZnNewCompany.vue'
import ZnClientMeet from './ZnClientMeet.vue'
import ZnRadishMeet from './ZnRadishMeet.vue'
import ZnSimple from './ZnSimple.vue'
import ZnCommunicate from './ZnCommunicate.vue'
import ZnAlphaRenzhi from './ZnAlphaRenzhi.vue'
import ZnCateRenzhi from './ZnCateRenzhi.vue'
import ZnBdFile from './ZnBdFile.vue'
import ZnCompanyInfo from './ZnCompanyInfo.vue'
import ZnMarketMoney from './ZnMarketMoney.vue'
import ZnZhaopin from './ZnZhaopin.vue'
import ZnRenzhiAll from './ZnRenzhiAll.vue'
import Zn137 from './Zn137.vue'
import Zn331 from './Zn331.vue'
import ZnBaoxiao from './ZnBaoxiao.vue'
export default {
  components: {
    ZnNewProject,
    ZnNewCompany,
    ZnClientMeet,
    ZnRadishMeet,
    ZnSimple,
    ZnCommunicate,
    ZnAlphaRenzhi,
    ZnCateRenzhi,
    ZnBdFile,
    ZnCompanyInfo,
    ZnMarketMoney,
    ZnZhaopin,
    ZnRenzhiAll,
    Zn137,
    Zn331,
    ZnBaoxiao,
  },
  data() {
    return {
      isShow: false,
      item: {},
      compMap: {
        新建项目: 'ZnNewProject',
        新建公司: 'ZnNewCompany',
        客户会面: 'ZnClientMeet',
        人选会面: 'ZnRadishMeet',
        BD邮件: 'ZnSimple',
        BD电话: 'ZnSimple',
        推荐邮件: 'ZnSimple',
        试单推荐邮件: 'ZnSimple',
        独家委托: 'ZnSimple',
        推荐确认: 'ZnSimple',
        承诺书: 'ZnSimple',
        离职辅导: 'ZnSimple',
        辞职信: 'ZnSimple',
        开票邮件: 'ZnSimple',
        催款邮件: 'ZnSimple',
        面试安排: 'ZnSimple',
        面试反馈: 'ZnSimple',
        沟通备注: 'ZnCommunicate',
        阿尔法认知: 'ZnAlphaRenzhi',
        职能认知: 'ZnCateRenzhi',
        BD材料: 'ZnBdFile',
        137: 'Zn137',
        331: 'Zn331',
        团队报销申请表填写要求: 'ZnBaoxiao',
        公司职能模块认知: 'ZnCompanyInfo',
        公司阿尔法认知: 'ZnCompanyInfo',
        公司薪酬职级: 'ZnCompanyInfo',
        公司高管: 'ZnCompanyInfo',
        人才流入流出: 'ZnCompanyInfo',
        客户公司介绍及高管: 'ZnCompanyInfo',
        客户沟通备注: 'ZnCompanyInfo',
        推荐须知: 'ZnCompanyInfo',
        面试地址: 'ZnCompanyInfo',
        市场薪酬: 'ZnMarketMoney',
        招聘信息: 'ZnZhaopin',
        认知汇总: 'ZnRenzhiAll',
      },
      activeComponent: ''
    }
  },
  methods: {
    open(item, withoutDefault) {
      try {
        this.activeComponent = ''
        this.item = item
        this.activeComponent = this.compMap[this.item.name] || 'ZnSimple'
        console.log('openTemplate', item, withoutDefault, this.activeComponent)
        // console.log('8====', localStorage[this.activeComponent])
        if (!this.activeComponent) return false
        this.$nextTick(()=>{
          // console.log('2======', this.$refs.compt, this.$refs.compt.initData)
          if (this.$refs.compt && this.$refs.compt.initData) {
            // const rid = item.rid || this.$route.params.id || ''
            // const storeName = rid?this.activeComponent+rid:this.activeComponent
            const storeName = this.activeComponent
            // console.log('3=====', storeName)
            if (withoutDefault) {
              localStorage.removeItem(storeName)
            }
            if (localStorage[storeName]) {
              // console.log('6====', localStorage[storeName])
              this.$refs.compt.initData(JSON.parse(localStorage[storeName]))
            } else {
              this.$refs.compt.initData()
            }
            this.$refs.compt.$refs.tplContent && (this.$refs.compt.$refs.tplContent.scrollTop = 0)
          }
          this.isShow = true
        })
      } catch (e) {
        console.error(e)
      }
      return true
    },
    checkLocal(item) {
      if (item.type != '解析模板') return false
      const shortName = item.name
      const comp = this.compMap[shortName]
      // const rid = item.rid || this.$route.params.id || ''
      // const storeName = rid?comp+rid:comp
      const storeName = comp
      const localStr = localStorage[storeName]
      const res = (localStr && Object.values(JSON.parse(localStr)).find(l=>l && l.length > 0))
      // console.loglog('1=====', comp, storeName, localStr)
      return res
    },
    show() {
      this.isShow = true
    },
    close() {
      this.isShow = false
    },
    closeTpl(param) {
      this.$parent.closeTpl(param)
    }
  }
}
</script>
<style>
  .moveR-enter-active,  .moveR-leave-active {
    transition: all 0.3s linear;
    transform: translateX(0);
  }
  .moveR-enter,  .moveR-leave {
    transform: translateX(100%);
  }
  .moveR-leave-to{
    transform: translateX(100%);
  }
  .zn-alpha-template {
    position: fixed;
    top: 60px;
    bottom: 0;
    width: 40%;
    right: 20%;
    border: 1px solid #eee;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  }
  .zn-template-head {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    padding: 10px 55px 10px 10px;
    border-bottom: 1px solid #eee;
    background-color: #fff;
    z-index: 2;
    height: 45px;
    line-height: 26px;
    overflow: hidden;
  }
  .zn-template-title {
    font-size: 16px;
    margin-right: 10px;
    color: #444;
  }
  .zn-text-grey {
    font-size: 12px;
    color: #aaa;
  }
  .zn-template-content {
    position: absolute;
    width: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    padding: 50px 10px;
  }
  .zn-template-content::-webkit-scrollbar-thumb {
    background-color: #cfe3ec;
  }
  .zn-content-item, .zn-content-item-inline {
    margin-bottom: 10px;
  }
  .zn-content-item-inline {
    display: flex;
    align-items: center;
  }
  .zn-content-item .zn-text-grey {
    margin-bottom: 5px;
  }
  .zn-template-btn {
    background-color: #2478b5;
    color: #fff;
    width: 100px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
  }
  .zn-template-submit {
    position: absolute;
    bottom: 10px;
    left: 50%;
    margin-left: -50px;
    background-color: #2478b5;
    color: #fff;
    width: 100px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    z-index: 2;
  }
  .zn-score-item {
    display: flex;
    align-items: center;
    height: 32px;
  }
  .zn-score-item i {
    font-size: 20px;
    color: #807f7f;
    text-align: center;
    cursor: pointer;
  }
</style>
